(() => {
  const normalizeHost = (host) => host.toLowerCase().replace(/^www\./, '');
  const storeHosts = new Set([normalizeHost(location.hostname), 'gerardneedham.com', 'gerardneedham.myshopify.com']);
  const prepare = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    let destination;
    try { destination = new URL(link.getAttribute('href'), location.href); } catch { return; }
    if (!['http:', 'https:'].includes(destination.protocol) || storeHosts.has(normalizeHost(destination.hostname))) return;
    link.target = '_blank';
    link.relList.add('noopener', 'noreferrer');
  };
  const scan = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root.matches?.('a[href]')) prepare(root);
    root.querySelectorAll('a[href]').forEach(prepare);
  };
  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') prepare(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  const prepareClickedLink = (event) => {
    if (event.target instanceof Element) prepare(event.target.closest('a[href]'));
  };
  document.addEventListener('click', prepareClickedLink, true);
  document.addEventListener('auxclick', prepareClickedLink, true);
})();
